import * as Constants from './Constants';

const initialState = {
  title: 'Device Setup',
  plansJson: '',
  plansAEM: '',
  selectedOption: 'SELF',
  oneTimeOfferOption: 'PROFESSIONAL',
  setFlag: true,
  showError: false,
  deviceSetupService: null,
  continueButtonStatus: false,
  setupInvalidError: false,
  deviceSetupError: false,
  setupNtfyMsg: null,
  setupShowError: false,
  updateSetupProcessStep: false,
  save5GappointmentStatus: false,
  initialVisitValue: false,
};

function deviceSetup(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_PLANS_SUCCESS:
      return { ...state, plansJson: action.response };
    case Constants.UPDATE_SELECTED_OPTION:
      return { ...state, selectedOption: action.response.data, oneTimeOfferOption: action.response.data };
    case 'SET_FLAG':
      return { ...state, setFlag: action.data };
    case Constants.ERR_OCCURED:
      return { ...state, showError: action.errorSetup, deviceSetupService: action.serviceinfo };
    case 'CONTINUE_BUTTON_ENABLE_STATE':
      return { ...state, continueButtonStatus: action.response };
    case Constants.SETUP_INVALIDCASE_ERROR:
      return { ...state, setupInvalidError: action.response };
    case Constants.DEVICE_SETUP_ERROR:
      return { ...state, deviceSetupError: action.response };
    case Constants.POST_DATA_PRO_INSTALLATION_DEVICE_SETUP_SUCCESS:
      return { ...state, updateProInstallationResponse: action.response };
    case Constants.CEF_APPOINTMENT_ERROR:
      return { ...state, appointmentError: action.response, appointmentNtfyMsg: action.errorMessage };
    case Constants.CEF_DEVICE_SETUP_ERROR:
      return { ...state, setupShowError: action.errorSetup, setupNtfyMsg: action.errorMessage };
    case 'UPDATED_SETUP_PROCESSSTEP':
      return { ...state, updateSetupProcessStep: action.value };
    case 'SET_SAVE_5G_APPOINTMENT_STATUS':
      return { ...state, save5GappointmentStatus: action.value };
    case 'INITIAL_VISIT':
      return { ...state, initialVisitValue: action.data };
    default:
      return state;
  }
}
export const saveSelectedOption = (state = {}, action) => {
  switch (action.type) {
    case 'SAVE_SELECTED_SETUP_OPTION': {
      //  debugger;
      return { ...state, setupOption: action.response };
    }
    default:
      return state;
  }
};

export default deviceSetup;
